import { render, staticRenderFns } from "./ComponentHistoryEntry.vue?vue&type=template&id=455c6bec&"
import script from "./ComponentHistoryEntry.vue?vue&type=script&lang=ts&"
export * from "./ComponentHistoryEntry.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentHistoryEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports